var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vgs-menu-links",class:_vm.mode,attrs:{"role":"navigation","aria-label":"Meta Navigation"}},_vm._l((_vm.metaLinks),function(item){return _c('span',{key:item.Label},[_c('a',{attrs:{"href":item.Url}},[_vm._v(_vm._s(item.Label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }